import IRhapsodyServer from "src/ServerEntities/IRhapsodyServer";
import styled from "styled-components"
import Select from "./Select";
import SelectItem from "./SelectItem";
import React from "react";
import { RolesContext } from "src/Roles/RolesContext";
import { SessionContext } from "src/Views/SessionContext";
import { getNamespacesForRole } from "src/Views/Ram/ramService";

interface IProps {
    headerInfo: IRhapsodyServer[],
    selectedNamespace?: string,
    selectedServer: number,
    setSelectedNamespace?: (selected: string) => void,
    setSelectedServer: (selected: number) => void
};

const NamespaceSelect = styled.span`
    & > p {
        margin: 0;
        text-align: center;
    }
    & > div {
        margin: 0;
    }
    border: 3px solid #1577AE;
    border-radius: 30px;
    margin: 0 20px 20px 0;
    padding: 5px 20px;
`;

const NamespaceContainer = styled.div`
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 20px;
`;

export const ServerContainer = styled.div`
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
`;

const ServerItemSelected = styled.div`
    border-radius: 30px;
    margin-right: 20px;
    padding: 8px;
    background-color: #1577AE;
    color: #FFF;
    width: 300px;
    text-align: center;
    font-size: 24px;
    margin-bottom: 20px;
`;

const ServerItemTitle = styled.h2`
    font-weight: 600;
    margin: 0;
    font-size: 1.4rem;
`;

const ServerItemNamespace = styled.p`
    margin: 0;
    font-size: 1rem;
`;

const ServerItem = styled.div`
    border-radius: 30px;
    margin-right: 20px;
    margin-bottom: 20px;
    padding: 8px;
    background-color: #ccc;
    color: #FFF;
    width: 300px;
    text-align: center;
    font-size: 24px;
    cursor: pointer;
`;

const SERVER_TYPE_GROUPS: {[key: string]: string} = {
    "Rhapsody": "Locker",
    "rhapsody": "Locker",
    "QIE": "Zone",
    "Ensemble": "Namespace",
    "InterSystems": "Namespace",
    "Mirth": "Channel Group"
};

export const serverToTab = (selectedServer: number, setSelectedServer: (selected: number) => void) => (server: IRhapsodyServer, index: number) => {
    const selectServer = (serverIndex: number) => () => {
        setSelectedServer(serverIndex);
    }
    if (selectedServer === index) {
        return <ServerItemSelected key={`rhapsody-server-${server.id}-dashboard`} onClick={selectServer(index)}>
            <ServerItemTitle>{server.server}</ServerItemTitle>
            <ServerItemNamespace>{server.namespace}</ServerItemNamespace>
        </ServerItemSelected>;
    }
        
    return <ServerItem key={`rhapsody-server-${server.id}-dashboard`} onClick={selectServer(index)}>
        <ServerItemTitle>{server.server}</ServerItemTitle>
        <ServerItemNamespace>{server.namespace}</ServerItemNamespace>
    </ServerItem>;
};

const ServerSelector = (props: IProps) => {
    const [namespaces, setNamespaces] = React.useState<string[]>([]);
    const { headerInfo, selectedNamespace, selectedServer, setSelectedNamespace, setSelectedServer } = props;
    const roleContext = React.useContext(RolesContext);
    const { state } = React.useContext(SessionContext);
    const currentRole = roleContext.state.role;

    React.useEffect(() => {
        if (setSelectedNamespace) {
            getNamespacesForRole(state.webToken, (namespaceData: string[]) => {
                setNamespaces(namespaceData);
                if (selectedNamespace && !namespaceData.includes(selectedNamespace)) {
                    setSelectedNamespace(namespaceData[0]);
                }
            }, (errorMessage: string) => {
                setSelectedNamespace('');
                setNamespaces([]);
            });
        }
    }, [currentRole]);

    return <NamespaceContainer>
        <ServerContainer>
            {headerInfo && headerInfo.map(serverToTab(selectedServer, setSelectedServer))}
        </ServerContainer>
        {headerInfo && setSelectedNamespace && namespaces.length > 0 && (
            <NamespaceSelect>
                {headerInfo[selectedServer] && <p>{SERVER_TYPE_GROUPS[headerInfo[selectedServer].serverType]}</p>}
                <Select
                    childValues={namespaces}
                    placeholder={`Choose ${headerInfo[selectedServer] ? SERVER_TYPE_GROUPS[headerInfo[selectedServer].serverType] : "namespace"}`}
                    margin="4px 24px 0px 0px"
                    value={selectedNamespace || ""}
                    onChange={setSelectedNamespace}
                >
                    {namespaces.sort().map((namespace: string) => <SelectItem key={`select-item-${namespace}`} itemKey={`select-item-${namespace}`} value={namespace}>
                        {namespace}
                    </SelectItem>)}
                </Select>
            </NamespaceSelect>
        )}
    </NamespaceContainer>;
};

export default ServerSelector;